module.exports = __webpack_public_path__ + "static/media/ill_asthma.bdd38221.svg";